import { CheckboxIcon } from "@aureskonnect/react-ui";
import ErrorToast from "@components/Common/ErrorTost";
import { t } from "i18next";
import React from "react";
import { toast } from "react-toastify";
import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { setDataSetupApk, store } from "../store";
import { formatZone } from "../GeneralConfigC&C/Zone/hooks";
import { formatCity } from "../GeneralConfigC&C/City/hooks";
import { isEmailValid } from "@helpers/general";
import { FORM_KEYS } from "../Website/Forms/constants";
import {
    INITIAL_PAYLINE,
    INITIAL_CLICKTOPAY,
    INITIAL_YAVIN,
} from "../GeneralConfigC&C/PaymentChoice/types";
import type { TFunction } from "i18next";
import type { TemplateState } from "../templateStore";

const DEFAULT_PARAM_LIVRAISON = {
    ST_MinCmd: { MinEmporter: 0, MinSurplace: 0, MinLivraison: 0 },
    Livraisonzone: false,
    LivraisonVille: true,
    LivraisonzoneMontant: false,
    LivraisonVilleMontant: false,
    stZoneLivraison: [],
    STVilleLivraison: [],
    stZoneLivraisonMontant: [],
    STVilleLivraisonMontant: [],
};

export function isClosed(hourOfUse: any) {
    let isClosedShop: boolean = false;
    let hour: any[] = JSON.parse(JSON.stringify(hourOfUse)).filter(
        (element: any) =>
            (element.HeureDebut_Matin === "" &&
                element.HeureFin_Matin !== "") ||
            (element.HeureDebut_Matin !== "" &&
                element.HeureFin_Matin === "") ||
            (element.HeureDebut_soir === "" && element.HeureFin_soir !== "") ||
            (element.HeureDebut_soir !== "" && element.HeureFin_soir === "")
    );

    if (hour.length !== 0) {
        isClosedShop = true;
    } else {
        isClosedShop = false;
    }

    return isClosedShop;
}

export async function getApkTemplateDateModification(
    template: any,
    iuudApk: string,
    reste: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const responseData = await fetchGlobal<{
            DateModification: string | null;
            message?: string;
        }>(
            `${process.env.REACT_APP_C_AND_C}/getApkTemplateDateModification/${iuudApk}`,
            { method: "GET" }
        );

        if (
            template.template.DateModification !==
                responseData.DateModification &&
            responseData.DateModification !== null
        ) {
            toast.warning(
                t(
                    "The template has been modified by another user. The changes you made will not be saved."
                ),
                {
                    position: "top-center",
                    autoClose: 2000,
                    theme: "colored",
                }
            );
            reste();
            return false;
        }

        return true;
    } catch (error: any) {
        console.error(
            "Erreur lors de la vérification de la date de modification :",
            error
        );
        toast.error(
            t(
                "An error occurred while checking the template modification date."
            ),
            {
                position: "top-center",
                autoClose: 2000,
                theme: "colored",
            }
        );
        return false;
    }
}

export function getPattern(orders: any, selectedRows: any, t: any) {
    let pattern = "";

    if (orders.localPattern && orders.localPattern !== "") {
        const label = orders.localPattern.label;
        if (label === t("Technical problem")) {
            pattern = "PROBLEME TECHNIQUE";
        } else if (label === t("Out of stock")) {
            pattern = "RUPTURE DE STOCK";
        } else if (label === t("Annual closure")) {
            pattern = "FERMETURE ANNUELLE";
        } else {
            pattern = label;
        }
    } else if (
        orders.isPauseOrders &&
        selectedRows &&
        selectedRows.length > 0
    ) {
        pattern = selectedRows[0].motif_interompre ?? selectedRows[0].pattern;
    }

    return pattern;
}

export function buildSavedData({
    selectedRows,
    etat,
    itemActivation,
    ItemSalesMethods,
    ItemPayementChoice,
    options,
    loyaltyAccount,
    hourOfUse,
    localOptionComposite,
    fuseau_horaire,
    orders,
    pattern,
    franchiseID,
}: {
    selectedRows: any;
    etat: any;
    itemActivation: any;
    ItemSalesMethods: any;
    ItemPayementChoice: any;
    options: any;
    loyaltyAccount: any;
    hourOfUse: any;
    localOptionComposite: any;
    fuseau_horaire: any;
    orders: any;
    pattern: any;
    franchiseID: any;
}): any {
    return {
        shopId: selectedRows[0]?.shopId ?? null,
        etat_boutique: etat,
        orderactive: itemActivation[1]?.active ?? false,
        vente_livraison: ItemSalesMethods[2]?.active ?? false,
        vente_a_emporter: ItemSalesMethods[1]?.active ?? false,
        vente_surplace: ItemSalesMethods[0]?.active ?? false,
        payement_caisse: ItemPayementChoice[1]?.active ?? false,
        payement_cb: ItemPayementChoice[0]?.active ?? false,
        client_anonyme: options.activateButton ?? false,
        info_client_anonyme: options.mandatoryEmail ?? false,
        payement_fid: loyaltyAccount?.isAuthorized ?? false,
        horraire_ouverture: hourOfUse,
        joignable_si_annulee: options.validatingOrder ?? false,
        parametre: buildLocalOptionComposite(
            localOptionComposite,
            selectedRows
        ),
        fuseau_horaire: fuseau_horaire,
        interompre_commande: orders.isPauseOrders ?? false,
        interompre_indetermine: orders.interrompreIndeterminé ?? false,
        interompre_jusqua:
            orders.interompreJusqua === " Invalid date Invalid date"
                ? ""
                : orders.interompreJusqua,
        motif_interompre: pattern,
        timetogo: orders.timePrepartion,
        paramlivraison: {
            ...DEFAULT_PARAM_LIVRAISON,
            ...(orders?.dataPrice ?? {}),
            stZoneLivraison: formatZone(
                orders?.dataPrice?.stZoneLivraison ?? []
            ),
            STVilleLivraison: formatCity(
                orders?.dataPrice?.STVilleLivraison ?? []
            ),
        },
        franchiseID: franchiseID,
    };
}

export function buildLocalOptionComposite(
    optionComposite: any,
    selectedRows: any
): any {
    const apkData = store.dataSetupApk || {};
    const existingComposite = apkData["composite Products"] || {};
    const licenceGodia = {
        ActivationGodia:
            optionComposite?.licenceGodia?.ActivationGodia ??
            existingComposite?.licenceGodia?.ActivationGodia ??
            selectedRows[0]?.["composite Products"]?.licenceGodia
                ?.ActivationGodia ??
            0,
        licenceGodia:
            optionComposite?.licenceGodia?.licenceGodia ??
            existingComposite?.licenceGodia?.licenceGodia ??
            selectedRows[0]?.["composite Products"]?.licenceGodia
                ?.licenceGodia ??
            "",
        Paramavantages:
            optionComposite?.licenceGodia?.Paramavantages ??
            existingComposite?.licenceGodia?.Paramavantages ??
            selectedRows[0]?.["composite Products"]?.licenceGodia
                ?.Paramavantages ??
            1,
    };
    const reglement = apkData?.reglement;
    const isPayline = reglement === 1;
    const isClickToPay = reglement === 3;
    const isYavin = reglement === 4 || reglement === 6;

    const payline = isPayline
        ? optionComposite?.payline ??
          existingComposite?.payline ??
          INITIAL_PAYLINE
        : existingComposite?.payline ?? INITIAL_PAYLINE;

    const CLICKTOPAY = isClickToPay
        ? optionComposite?.CLICKTOPAY ??
          existingComposite?.CLICKTOPAY ??
          INITIAL_CLICKTOPAY
        : existingComposite?.CLICKTOPAY ?? INITIAL_CLICKTOPAY;

    const YAVIN = isYavin
        ? optionComposite?.YAVIN ?? existingComposite?.YAVIN ?? INITIAL_YAVIN
        : existingComposite?.YAVIN ?? INITIAL_YAVIN;

    return {
        CMD_DIFFERE: {
            ACITVE: optionComposite?.CMD_DIFFERE?.ACITVE ?? false,
            NBR_JOUR: Number(optionComposite?.CMD_DIFFERE?.NBR_JOUR ?? 0),
        },
        REGLEGRATUITE:
            optionComposite?.REGLEGRATUITE &&
            optionComposite.REGLEGRATUITE !== ""
                ? optionComposite.REGLEGRATUITE
                : existingComposite?.REGLEGRATUITE ?? "",
        licenceGodia,
        payline,
        CLICKTOPAY,
        YAVIN,
    };
}

export function validateFormEmails(
    t: TFunction,
    templateState: TemplateState
): boolean {
    const forms = templateState?.template?.SiteWeb?.Forms;
    const activeForms = FORM_KEYS.map((f) => f.key).filter(
        (key) => forms?.[key]?.Activer !== false
    );

    if (activeForms.length === 0) {
        return true;
    }

    const emailConfig = forms?.EmailConfig;
    const useGlobalEmail = emailConfig?.UseGlobalEmail ?? true;

    if (useGlobalEmail) {
        if (
            !emailConfig?.GlobalEmail ||
            !isEmailValid(emailConfig.GlobalEmail)
        ) {
            ErrorToast(
                t("Please configure a valid email address for form submissions")
            );
            return false;
        }
    } else {
        const invalidForms = activeForms.filter(
            (key) =>
                !emailConfig?.[key]?.Email ||
                !isEmailValid(emailConfig?.[key]?.Email ?? "")
        );
        if (invalidForms.length > 0) {
            const formNames = invalidForms
                .map((key) =>
                    t(FORM_KEYS.find((f) => f.key === key)?.labelKey || key)
                )
                .join(", ");
            ErrorToast(
                `${t(
                    "Please configure a valid email address for the form"
                )}: ${formNames}`
            );
            return false;
        }
    }

    return true;
}

export async function validateFormData(
    t: any,
    ItemSalesMethods: any[],
    ItemPayementChoice: any[],
    optionComposite: any,
    isShopClosed: boolean,
    orders: any,
    overLaps: any[],
    isErreur: boolean,
    ccSetup: () => Promise<void>
): Promise<boolean> {
    let valid = true;

    try {
        if (
            ItemSalesMethods[0]?.active === false &&
            ItemSalesMethods[1]?.active === false &&
            ItemSalesMethods[2]?.active === false
        ) {
            ErrorToast(
                t("Attention, you must activate at least one mode of sale.")
            );
            valid = false;
        } else if (
            ItemPayementChoice.length > 0 &&
            ItemPayementChoice[0]?.active === false &&
            ItemPayementChoice[1]?.active === false
        ) {
            ErrorToast(
                t(
                    "Please note that you must activate at least one payment method."
                )
            );
            valid = false;
        } else if (
            Object.keys(optionComposite).length > 0 &&
            Boolean(optionComposite?.licenceGodia?.ActivationGodia) &&
            optionComposite?.licenceGodia?.licenceGodia !== "" &&
            !/^[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}$/.test(
                optionComposite?.licenceGodia?.licenceGodia
            )
        ) {
            ErrorToast(t("Warning, please enter a valid interconnection key."));
            valid = false;
        } else if (isShopClosed === true) {
            ErrorToast(
                t(
                    "Attention, no schedule has been entered, which means that the shop will be considered closed."
                )
            );
            valid = false;
        } else if (
            Object.keys(orders).length > 0 &&
            orders?.delivery < 60 &&
            orders?.onTheSpot < 60 &&
            orders?.toTake < 60 &&
            !isErreur &&
            overLaps.every(
                (element: any) =>
                    element.HeureDebut_Matin === false &&
                    element.HeureFin_Matin === false &&
                    element.HeureDebut_soir === false &&
                    element.HeureFin_soir === false &&
                    element.inputDebut_Matin === false &&
                    element.inputFin_Matin === false &&
                    element.inputDebut_Soir === false &&
                    element.inputFin_Soir === false
            )
        ) {
            await ccSetup();
        }
    } catch (error) {
        console.error("Validation error:", error);
        ErrorToast(t("An unexpected error occurred during validation."));
        valid = false;
    }

    return valid;
}

export async function uploadApkTemplate(
    iuudApk: string,
    formData: FormData,
    reste: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
): Promise<any> {
    try {
        await fetchGlobal(
            `${process.env.REACT_APP_C_AND_C}/Setting/setApkTemplate/${iuudApk}`,
            {
                method: "POST",
                body: formData,
            }
        ).catch((err) => {
            console.error("Erreur dans fetchGlobal:", err);
            throw err;
        });

        toast.success(`${t("Template saved successfully")!}`, {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            icon: <CheckboxIcon height={25} width={25} fill="white" />,
        });
        reste();

        return true;
    } catch (error: any) {
        console.error("Upload error:", error);
        throw new Error(
            error.message || "An unexpected error occurred during the upload."
        );
    }
}

export async function getDataShop(
    iuudApk: any,
    selectedRows: any,
    franchiseID: any,
    userID: any,
    setMergedData: Function,
    setIsFetchingData: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    setIsFetchingData(true);
    const urlApi = `${process.env.REACT_APP_API_V2_URL}/settings/shop/c&c/V2?&shopUid=${selectedRows?.uid_boutique}&franchiseId=${franchiseID}&userId=${userID}&iuudApk=${iuudApk}`;
    try {
        const result = await fetchGlobal<{
            data?: any[];
        }>(urlApi, { method: "GET" });

        const merged = {
            ...selectedRows,
            ...result?.data?.[0],
        };
        const selectedTemplate = merged?.template;

        templateActions.setTemplate(
            selectedTemplate || {},
            selectedTemplate?.DateModification || "",
            iuudApk || ""
        );

        setDataSetupApk(merged);
        setMergedData(merged);
    } catch (error) {
        ErrorToast(t("Failed to load shop data"));
        setDataSetupApk(selectedRows[0] || {});
        setMergedData(selectedRows[0]);
    } finally {
        setIsFetchingData(false);
    }
}

export async function postData(
    url: string,
    data: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>,
    {
        onSuccess,
        onError,
        onFinally,
    }: {
        onSuccess?: (result: any) => void;
        onError?: (error: any) => void;
        onFinally?: () => void;
    } = {}
) {
    try {
        const result = await fetchGlobal<any>(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (result.error === true) {
            ErrorToast(`${t("There's an error")}!`);
            onError?.(result);
        } else {
            onSuccess?.(result);
        }
    } catch (error) {
        console.error("Erreur lors de l’envoi :", error);
        ErrorToast(`${t("There's an error")}!`);
        onError?.(error);
    } finally {
        onFinally?.();
    }
}

export const prepareSetupData = async ({
    selectedRows,
    itemActivation,
    ItemSalesMethods,
    ItemPayementChoice,
    options,
    loyaltyAccount,
    hourOfUse,
    optionComposite,
    fuseau_horaire,
    orders,
    isValidationNumTheSpot,
    isValidationNumToTake,
    isValidationPriceTheSpot,
    isValidationPriceToTake,
    isValidationPeriodToTake,
    isValidationNumDelivrey,
    franchiseID,
}: any) => {
    const isValidation =
        isValidationNumTheSpot ||
        isValidationNumToTake ||
        isValidationPriceTheSpot ||
        isValidationPriceToTake ||
        isValidationPeriodToTake ||
        isValidationNumDelivrey;

    const pattern = getPattern(orders, selectedRows, t);
    const etat: number = itemActivation[0].active === true ? 1 : 0;

    const savedData = await buildSavedData({
        selectedRows,
        etat,
        itemActivation,
        ItemSalesMethods,
        ItemPayementChoice,
        options,
        loyaltyAccount,
        hourOfUse,
        localOptionComposite: optionComposite,
        fuseau_horaire,
        orders,
        pattern,
        franchiseID,
    });

    return { savedData, isValidation };
};
